import axios from 'axios'
import router from '@/router'

const request = axios.create({
  baseURL: process.env.VUE_APP_BASE_API || 'http://localhost:3000/api',
  timeout: 10000
})

request.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

request.interceptors.response.use(
  response => {
    return response.data
  },
  error => {
      if (error.response) {
          switch (error.response.status) {
              case 401:
                  // 未授权
                  handleUnauthorized()
                  break
              case 302:
                  // 重定向处理
                  handleRedirect(error.response)
                  break
              default:
                  console.error('请求错误:', error.response.status)
          }
      }
      return Promise.reject(error)
  }
)

function handleRedirect(response) {
    const redirectUrl = response.headers.location
    // 判断是否是登录相关的重定向
    if (redirectUrl && redirectUrl.includes('/login')) {
        // 清除本地token
        localStorage.removeItem('token')
        // 清空store中的用户信息
        // store.commit('clearUserInfo')
        // 跳转到登录页
        router.push('/')
    }
}

function handleUnauthorized() {
    // 清除用户信息
    localStorage.removeItem('token')
    // store.commit('clearUserInfo')
    // 跳转到登录页
    router.push('/')
}

export default request
